import React from 'react';
import './Footer.scss';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      <footer>
        <div className="app_footer row mx-0">
          If you have any questions or issues please contact
          <Link to ="mailto:DigitalAsset.support@thermofisher.com" target='_blank' rel="noreferrer">
            DigitalAsset.support@thermofisher.com 
          </Link>          
        </div>
      </footer>
    </>
  );
};

export default Footer;
